export default __webpack_public_path__ + "static/1-055c67bd8769d3f20a793ece02459d4a.jpeg";